import { ref } from "vue";

const count = ref(0);

export const pageLoader = {
  count,

  get loading() {
    return count.value > 0;
  },

  start() {
    count.value++;
    console.log("START:", count.value);
  },

  stop() {
    count.value = Math.max(0, count.value - 1);
    console.log("STOP:", count.value);
  },

  reset() {
    count.value = 0;
  }
};

